import { lazy } from 'react';
export * from './MarkdownEditor.constants';
export * from './MarkdownEditor.types';

export default lazy(() => /* webpackChunkName: "MarkdownEditor" */ import('./MarkdownEditor'));
